import styles from './routeFallback.module.scss';

export function RouteFallback() {
  return (
    <div className={styles.page} role="status" aria-label="Loading">
      <img src="/mark.svg" alt="" className={styles.mark} />
      <span className={styles.bar} aria-hidden="true" />
      <span className={styles.label}>Loading the desk</span>
    </div>
  );
}
